<template>
  <div class="card card-body shadow-sm">
    <validation-observer
      ref="form_create_entry"
      v-slot="{ passes, valid, validated }"
    >
    <app-basic-table
      ref="basic_table"
      :table-name="$t('users.user list')"
      :filters.sync="filters"
      :setting-columns="columns"
      :endpoint-list="ENDPOINT.BOOK_RESERVATION_LIST"
      @resetAllSearch="onResetAllSearch"
      @searched="onSearch"
    >

      <template v-slot:filters>
        <div class="row">
          <div class="col-xl-4 col-lg-4 col-sm-12">
            <div class="form-group">
              <label class="col-xl-12 col-lg-12 col-sm-12">{{ filters.status_booking.label }}</label>
              <div class="col-xl-12 col-lg-9 col-sm-9">
                <app-radio v-for="(item, index) in RESERVATION_CONSTANT.FILTER_STATUS"
                           :isMarginLeft="index !=0 ? true : false" :key="item.id" :label="item.name"
                           :val="item.id" v-model="filters.status_booking.value"/>
              </div>
            </div>
          </div>
          <div class="col-xl-4 col-lg-4 col-sm-12">
            <div class="form-group">
              <label class="col-xl-12 col-lg-12 col-sm-12 ">{{ filters.customer_name.label }}</label>
              <div class="col-xl-9 col-lg-9 col-sm-9">
                <app-input :name="filters.customer_name.name" input-style="normal"
                           v-model="filters.customer_name.value"/>
              </div>
            </div>
          </div>
        </div>

          <div class="row mt-2">
            <div class="col-xl-3 col-lg-5 col-md-5 col-sm-3">
              <div class="row mr-0">
                <div class="col-xl-8 col-lg-8 col-sm-8">
                  <div class="form-group">
                    <label class="pl-0">{{ filters.date_start.label }}</label>
                    <app-date-range-picker
                      :rules="`from_date_list_page:${filters.date_end.value}`"
                      :name="filters.date_start.name"
                      v-model="filters.date_start.value"
                      timePicker24Hour="false"
                      format="YYYY-MM-DD"
                      @input="filters.date_start.value = $event"
                    />
                  </div>
                </div>
                <div class="col-xl-4 col-lg-4 col-sm-4" v-if="filters.date_start.value === null ||
                 filters.date_start.value === undefined || filters.date_start.value === ''">
                  <div class="form-group start_date mb-0">
                    <label class="">{{ filters.start_time.label }}</label>
                    <app-select  :name="filters.start_time.name"
                                 input-style="normal"
                                 v-model="filters.start_time.value"
                                 :disabled="true"/>
                  </div>
                </div>

                <div class="col-xl-4 col-lg-4 col-sm-4" v-else>
                  <div class="form-group start_date mb-0">
                    <label class="">{{ filters.start_time.label }}</label>
                    <app-select  :rules="`start_time_and_date:${filters.close_time.value}, ${filters.date_start.value}, ${filters.date_end.value}`"
                                 :name="filters.start_time.name"
                                 input-style="normal"
                                 v-model="filters.start_time.value"
                                 :disabled="false"
                                 :options-data="meta.unitTimes"/>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-xl-1 col-lg-2 col-md-2 col-sm-1 ">
              <div class="form-group mb-0 w-100">
                <span class="d-flex justify-content-center align-items-center" style="margin-top: 30%; font-weight: bold; font-size: 24px;">~</span>
              </div>
            </div>

            <div class="col-xl-3 col-lg-5 col-md-5 col-sm-3">
              <div class="row ml-0 pr-1">
                <div class="col-xl-8 col-lg-8 col-sm-8">
                  <div class="form-group">
                    <label class="pl-0">{{ filters.date_end.label }}</label>
                    <app-date-range-picker
                      :name="filters.date_end.name"
                      v-model="filters.date_end.value"
                      timePicker24Hour="false"
                      format="YYYY-MM-DD"
                      @input="filters.date_end.value = $event"
                    />
                  </div>
                </div>
                <div class="col-xl-4 col-lg-4 col-sm-4" v-if="filters.date_end.value === null ||
                filters.date_end.value === undefined || filters.date_end.value === ''">
                  <div class="start_date">
                    <label class="">{{ filters.close_time.label }}</label>
                    <app-select :name="filters.close_time.name"
                                input-style="normal"
                                v-model="filters.close_time.value"
                                :disabled="true"/>
                  </div>
                </div>

                <div class="col-xl-4 col-lg-4 col-sm-4" v-else>
                  <div class="start_date">
                    <label class="">{{ filters.close_time.label }}</label>
                    <app-select :name="filters.close_time.name"
                                input-style="normal"
                                v-model="filters.close_time.value"
                                :disabled="false"
                                :options-data="meta.unitTimes"/>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row mt-2">
            <div class="col-xl-4 col-lg-4 col-sm-4 pl-0">
              <div class="form-group">
                <label class="col-xl-12 col-lg-12 col-sm-12 ">{{ filters.apartment_id_equal.label }}</label>
                <div class="col-xl-9 col-lg-9 col-sm-12">
                  <app-select :name="filters.apartment_id_equal.name"
                              input-style="normal"
                              v-model="filters.apartment_id_equal.value"
                              :options-data="meta.apartments" />
                </div>
              </div>
            </div>
            <div class="col-xl-4 col-lg-4 col-sm-4 ">
              <div class="form-group">
                <label class="col-xl-12 col-lg-12 col-sm-12 ">{{ filters.facility_id_equal.label }}</label>
                <div class="col-xl-9 col-lg-9 col-sm-12 ">
                  <app-select :name="filters.facility_id_equal.name"
                              input-style="normal"
                              v-model="filters.facility_id_equal.value"
                              :options-data="meta.facilities" />
                </div>
              </div>
            </div>
            <div class="col-xl-4 col-lg-4 col-sm-4">
              <div class="form-group">
                <label class="col-xl-12 col-lg-12 col-sm-4 ">{{ filters.plan_id_equal.label }}</label>
                <div class="col-xl-9 col-lg-9 col-sm-12">
                  <app-select :name="filters.plan_id_equal.name"
                              input-style="normal"
                              v-model="filters.plan_id_equal.value"
                              :options-data="meta.plans" />
                </div>
              </div>
            </div>
          </div>

      </template>



      <template v-slot:table-menu-right>
        <button @click="handleBtnCreateClick()" class="btn btn-warning">
          {{ $t("common.create") }}
        </button>
      </template>

      <template v-slot:body-cell-edit="props">
        <td class="app-align-middle text-center app-p-none">
          <button
            @click="handleBtnUpdateClick(props.row)"
            class="btn btn-primary"
          >
            {{ $t("common.edit") }}
          </button>
        </td>
      </template>


      <template v-slot:body-cell-apartment_id="props">
        <td class="app-align-middle">
          <p :data-original-title="props.row.apartment_name" style="color: #007bff;"
             @click="handlerApartmentNameClick(props.row)" class="apartment_name app-table-p app-cell-tooltip mb-0">
                  {{props.row.apartment_name}}
          </p>
        </td>
      </template>

      <template v-slot:body-cell-facility_id="props">
        <td class="app-align-middle">
          <p :data-original-title="props.row.facility_name" style="color: #007bff;"
             @click="handlerFacilityNameClick(props.row)" class="apartment_name app-table-p app-cell-tooltip mb-0">
            {{props.row.facility_name}}
          </p>
        </td>
      </template>

      <template v-slot:body-cell-plan_id="props">
        <td class="app-align-middle">
          <p :data-original-title="props.row.plan_name" style="color: #007bff;" v-if="props.row.plan_name != null"
             @click="handlerPlanNameClick(props.row)" class="apartment_name app-table-p app-cell-tooltip mb-0">
            {{props.row.plan_name}}
          </p>
        </td>
      </template>

      <template v-slot:body-cell-status_booking="props">
        <td class="app-align-middle">
          <p class=" app-table-p app-cell-tooltip mb-0">
            {{getStatusName(props.row.status_booking)}}
          </p>
        </td>
      </template>
    </app-basic-table>
    </validation-observer>
  </div>
</template>

<script>
  import AppBasicTable from "@components/_common/list/AppBasicTable";
  import AppDateRangePicker from "../../../components/forms/AppDateRangepicker";
  import {ENDPOINT} from "../../../constants/api";
  import {FACILITIES_CONSTANT} from "../../../constants/facilities";
  import {INFORMATION_CONSTANT} from "../../../constants/information";
  import {RESERVATION_CONSTANT} from "../../../constants/reservation";
  export default {
    name: "ReservationListPage",
    components: {
      "app-basic-table": AppBasicTable,
      AppDateRangePicker,
    },
    data() {
      return {
        idCache: null,
        paramGetList: {},
        filters: {
          status_booking: {
            name: "status_booking_equal",
            condition: "equal",
            label: this.$t("reservation.status")
          },
          date_start: {
            name: "date_start",
            condition: "equal",
            label: this.$t("reservation.date")
          },
          date_end: {
            name: "date_end",
            condition: "equal",
            label: this.$t("reservation.date")
          },
          start_time: {
            name: "start_time_between",
            condition: "between",
            label: this.$t("reservation.time")
          },
          close_time: {
            name: "close_time_between",
            condition: "between",
            label: this.$t("reservation.time")
          },
          customer_name : {
            name : "customer_name",
            condition: "like",
            label: this.$t("reservation.filter_customer_name")
          },
          apartment_id_equal: {
            name: "apartment_id",
            condition: "equal",
            label: this.$t("common.mansion")
          },
          facility_id_equal: {
            name: "facility_id",
            condition: "equal",
            label: this.$t("facilities.filter_facility_id")
          },
          plan_id_equal: {
            name: "plan_id",
            condition: "equal",
            label: this.$t("reservation.plan")
          },
        },
        columns: [
          {name: "id", label: this.$t("common.id"), sortable: true, textAlign: 'text-center'},
          {name: "apartment_id", label: this.$t("common.mansion"), sortable: true, textAlign: 'text-center'},
          {name: "customer_name", label: this.$t("reservation.customer"), sortable: true},
          {name: "date", label: this.$t("reservation.date"), sortable: true, textAlign: 'text-center'},
          {name: "start_time_with_format", label: this.$t("reservation.start_time") , textAlign: 'text-center'},
          {name: "close_time_with_format", label: this.$t("reservation.close_time"), textAlign: 'text-center'},
          {name: "facility_id", label: this.$t("reservation.facility"), sortable: true, textAlign: 'text-center'},
          {name: "plan_id", label: this.$t("reservation.plan"), sortable: true, textAlign: 'text-center'},
          {name: "status_booking", label: this.$t("reservation.status"), sortable: true, textAlign: 'text-center'},
          {name: "created_at", label: this.$t("reservation.created_at"), sortable: true, textAlign: 'text-center'},
          {name: "edit", label: this.$t("common.edit"), textAlign: 'text-center'},
        ],
        meta: {
          apartments: [],
          unitTimes : [],
          // plans : [],
          facilities : []
        },
        endPoint: ''
      };
    },
    watch : {
      "filters.apartment_id_equal.value" : async function(value) {
        this.getParamsFilters({apartment_id : value, facility_id :  this.filters.facility_id_equal.value})
      },
      "filters.facility_id_equal.value" : function(value) {

        this.getParamsFilters({apartment_id : this.filters.apartment_id_equal.value, facility_id :  value})
      },
      "filters.start_time.value" : async function(value) {
        await this.$refs.form_create_entry.validate()
      },
      "filters.close_time.value" : async function(value) {
        await this.$refs.form_create_entry.validate()
      },
    },
    methods: {
      handleBtnCreateClick() {
        this.$router.push({name: this.ROUTES.ADMIN.RESERVATION_CREATE})
      },
      handleBtnUpdateClick(entry) {
        this.$router.push({name: this.ROUTES.ADMIN.RESERVATION_EDIT, params: {id: entry.id}})
      },
      handleBtnManageStatus(entry) {

        this.$router.push({name: this.ROUTES.ADMIN.FACILITY_MANAGE_STATUS, params: {id: entry.id}})
      },
      handlerApartmentNameClick(entry) {
        let routeApartment = this.$router.resolve({name: this.ROUTES.ADMIN.APARTMENT_EDIT, params: {id: entry.apartment_id}});
        window.open(routeApartment.href, '_blank');
      },
      handlerFacilityNameClick(entry) {
        let routeFacility = this.$router.resolve({name: this.ROUTES.ADMIN.FACILITY_EDIT, params: {id: entry.facility_id}});
        window.open(routeFacility.href, '_blank');
      },
      handlerPlanNameClick(entry) {
        let routePlan = this.$router.resolve({name: this.ROUTES.ADMIN.FACILITY_PLAN_EDIT, params: {facility_id: entry.facility_id, id : entry.plan_id}});
        window.open(routePlan.href, '_blank');
      },
      onResetAllSearch() {
        this.$router.push({name: this.$route.name,
          query: {
            'filters.date.equal' : moment().format('YYYY-MM-DD'),
            'filters.status_booking_equal.equal' : 'all',
            'filters.apartment_id.equal' : 'all',
            'filters.start_time_between.between' : 'all',
            'filters.close_time_between.between' : 'all',
            'filters.facility_id.equal' : 'all',
            'filters.plan_id.equal' : 'all'
          }
        }).catch(e => {
        console.log('no warning console');
      })
      },
      getStatusName(status) {
        let data = RESERVATION_CONSTANT.FILTER_STATUS.find(({id}) => id === status);
        return data.name
      },
      async onSearch() {
        await this.$refs.form_create_entry.validate()
      },
      getParamsFilters(params) {
        this.$request.get(this.ENDPOINT.UI_HELPER_RESERVATION, params).then(res => {
          this.meta = {
            unitTimes: res.data.filter_time,
            apartments: res.data.apartments,
            plans : res.data.plans,
            facilities : res.data.facilities
          }

          this.meta.unitTimes.unshift({
            id: "all",
            name: ""
          })

          this.meta.apartments.unshift({
            id: "all",
            name: ""
          })

          this.meta.plans.unshift({
            id: "all",
            name: ""
          })

          this.meta.facilities.unshift({
            id: "all",
            name: ""
          })

          let vm = this
          if (!this.meta.facilities.find(({id}) => id === parseInt(vm.filters.facility_id_equal.value))) {
            this.filters.facility_id_equal.value = 'all';
          }

          if (!this.meta.plans.find(({id}) => id === parseInt(vm.filters.plan_id_equal.value))) {
            this.filters.plan_id_equal.value = 'all';
          }
        })
      }
    },
    mounted: function () {
        // this.getParamsFilters({})

    },
  }
</script>
